import { InjectionToken } from '@angular/core';
import { PaginatedAPIInterface } from '@vendasta/galaxy/table';
import { Observable } from 'rxjs';

export interface CrmBoardDatasourceInterface<RowType, FilterType, SortType = void>
  extends PaginatedAPIInterface<RowType, FilterType, SortType> {
  readonly searchTerm$: Observable<string>;
  readonly filters$: Observable<FilterType[]>;
  readonly sorting$: Observable<SortType[]>;

  setSearchTerm(searchTerm?: string): void;
  setFilters(filters?: FilterType[]): void;
  setSorting(sorting?: SortType[]): void;
}

export interface CrmBoardColumnInterface<FilterType, RowType = unknown> {
  id: string;
  name: string;
  filters: FilterType[];
  mutation?: (row: RowType) => Promise<unknown>;
  probability?: number;
}

export interface CrmBoardItemUpdatedEvent<RowType, FilterType> {
  item: RowType;
  column: CrmBoardColumnInterface<FilterType, RowType>;
  from: CrmBoardColumnInterface<FilterType, RowType>;
}

export type ItemUpdateStrategy = 'none' | 'cache' | 'refresh';

export type ItemCompareFn<RowType> = (a: RowType, b: RowType) => boolean;
export type ItemClickedEventFn<RowType> = (r: RowType) => CrmBoardItemClickedEvent;

export const CrmBoardItemCompareToken = new InjectionToken<ItemCompareFn<unknown>>('CrmBoardItemCompareToken');
export const CrmBoardItemClickedToken = new InjectionToken<ItemClickedEventFn<unknown>>('CrmBoardItemClickedToken');

export interface CrmBoardColumnMetadataInterface {
  hasMore: boolean;
  totalResults?: number;
}

export interface CrmBoardItemClickedEvent {
  objectId: string;
}
